(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('WikiNavbarController', WikiNavbarController);

    WikiNavbarController.$inject = ['$scope', '$state', '$stateParams', '$window', '$uibModal', 'WikiSpace', 'Principal', 'Auth'];

    function WikiNavbarController($scope, $state, $stateParams, $window, $uibModal, WikiSpace, Principal, Auth) {
        var vm = this;

        vm.spaces = [];
        vm.currentSpaceId = null;
        vm.account = null;
        vm.switchSpace = switchSpace;
        vm.openNewSpaceDialog = openNewSpaceDialog;
        vm.logout = logout;

        resolveCurrentSpaceId();
        loadSpaces();
        loadAccount();

        $scope.$on('$stateChangeSuccess', function () {
            resolveCurrentSpaceId();
        });

        function loadAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
            });
        }

        function resolveCurrentSpaceId() {
            if ($stateParams.spaceId) {
                vm.currentSpaceId = parseInt($stateParams.spaceId, 10);
                return;
            }
            var lastId = $window.localStorage.getItem('wiki.lastSpaceId');
            if (lastId) {
                vm.currentSpaceId = parseInt(lastId, 10);
            }
        }

        function loadSpaces() {
            WikiSpace.query({}, function (data) {
                vm.spaces = data;
                if (!vm.currentSpaceId && data.length > 0) {
                    var geral = data.filter(function (s) {
                        return s.nome === 'Geral';
                    })[0];
                    vm.currentSpaceId = geral ? geral.id : data[0].id;
                }
            });
        }

        function switchSpace(spaceId) {
            if (!spaceId) {
                return;
            }
            $window.localStorage.setItem('wiki.lastSpaceId', spaceId);
            vm.currentSpaceId = spaceId;
            $state.go('wiki-space', {spaceId: spaceId});
        }

        function openNewSpaceDialog() {
            $uibModal.open({
                templateUrl: 'app/entities/wiki/wiki-space-dialog.html',
                controller: 'WikiSpaceDialogController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function () {
                        return {id: null, nome: null, descricao: null, ordem: 100};
                    }
                }
            }).result.then(function (result) {
                WikiSpace.query({}, function (data) {
                    vm.spaces = data;
                });
                switchSpace(result.id);
            }, angular.noop);
        }

        function logout() {
            Auth.logout();
            $state.go('login');
        }
    }
})();
